import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

/** Host y puertos por defecto coinciden con `firebase.json` (emuladores locales). */
const emulatorHost = import.meta.env.VITE_FIREBASE_EMULATOR_HOST ?? '127.0.0.1';
const authEmulatorPort = Number(import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT ?? 9099);
const firestoreEmulatorPort = Number(
  import.meta.env.VITE_FIREBASE_FIRESTORE_EMULATOR_PORT ?? 8080,
);

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/**
 * Emuladores locales solo si `VITE_USE_EMULATORS=true` en `.env` (vite dev).
 * Sin esa variable, `vite dev` usa Firebase en la nube como el build de producción.
 */
export const usesLocalFirebaseEmulators =
  import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true';

if (usesLocalFirebaseEmulators) {
  try {
    connectAuthEmulator(auth, `http://${emulatorHost}:${authEmulatorPort}`, {
      disableWarnings: true,
    });
    connectFirestoreEmulator(db, emulatorHost, firestoreEmulatorPort);
  } catch {
    // Emuladores apagados, reconexión en HMR o `connect*` ya aplicado.
  }
}

export default app;
